import React, { FC, useEffect } from 'react';

import { Stack } from '@mui/system';

import { adminActions, successOrSelector } from '@pharmaplan/common';

import NoAvailabilities from '../MatchingAvailabilities/NoAvailabilities';
import useAdminNotes from '../../../hooks/Admin/AdminNotes/useAdminNotes';
import AdminCreateNote from './AdminCreateUpdateNotes/AdminCreateNote';
import { useAppSelector } from '../../../hooks/useAppSelector';
import { useAppDispatch } from '../../../hooks/useAppDispatch';
import { AdminNotesType } from '../../../helpers/Constants';
import { setBack } from '../../../actions/drawerActions';
import DynamicTable from '../../DynamicTable';
import strings from '../../../localization';

import styles from './styles';

interface IAdminNotes {
  id: string;
  notesType: AdminNotesType;
  back?: () => void;
}

const successActions = [adminActions.getAllNotes, adminActions.getAllPharmacyNotes];

const AdminNotes: FC<IAdminNotes> = ({ id, notesType, back }) => {
  const dispatch = useAppDispatch();

  const { table, data } = useAdminNotes(id, notesType);

  const loadSuccess = useAppSelector((state) =>
    successOrSelector(successActions, state));

  const emptyContainerComponent = data.length === 0 ? (
    <NoAvailabilities message={strings.noDataAvailable} />
  ) : null;

  useEffect(() => {
    dispatch(setBack(back ?? null));

    return () => {
      dispatch(setBack(null));
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Stack sx={styles.stackContainer}>
      <DynamicTable
        table={table}
        loadSuccess={loadSuccess}
        noContainerStyling
        showHeader={false}
        hidePagination
        emptyContainerComponent={emptyContainerComponent}
        customHeader={<AdminCreateNote id={id} notesType={notesType} />}
      />
    </Stack>
  );
};

export default AdminNotes;
